import { collection, getDocs, query, where } from 'firebase/firestore';

function snapshotToRecords(snapshot) {
  return (snapshot?.docs || []).map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }));
}

export async function loadCollectionRecords(db, collectionName = '') {
  if (!collectionName) return [];

  const snapshot = await getDocs(collection(db, collectionName));
  return snapshotToRecords(snapshot);
}

export async function loadRecordsByEquality(
  db,
  {
    collectionName = '',
    field = '',
    value = '',
    operator = '==',
    // Pass 82A.1 — optional SECOND equality clause, so a tenant-scoped read (e.g. organizationId + instructorId) is
    // filtered server-side rather than fetched globally and filtered in memory. Applied to both the live query and the
    // in-memory mock fallback.
    andField = '',
    andValue = '',
  } = {}
) {
  if (!collectionName || !field) return [];

  const collectionRef = collection(db, collectionName);

  if (typeof query === 'function' && typeof where === 'function') {
    try {
      const clauses = [where(field, operator, value)];
      if (andField) clauses.push(where(andField, '==', andValue));
      const snapshot = await getDocs(query(collectionRef, ...clauses));
      return snapshotToRecords(snapshot);
    } catch (error) {
      console.warn(`Falling back from query on ${collectionName}.${field} (${operator}):`, error);
    }
  }

  const records = await loadCollectionRecords(db, collectionName);
  let out = operator === 'array-contains'
    ? records.filter((record) => Array.isArray(record?.[field]) && record[field].includes(value))
    : records.filter((record) => record?.[field] === value);
  if (andField) out = out.filter((record) => record?.[andField] === andValue);
  return out;
}
